import Vue from 'vue'
import VueI18n from 'vue-i18n'
import JTF from '@beetronix/jtf'
import sharedTranslates from './shared-translates.json'
import routesTitle from './routes-title.json'

Vue.use(VueI18n)
Vue.use(JTF)

const jtf = new JTF({
	locales: require.context('./locales'),
	sharedTranslates: [
		{ translates: sharedTranslates },
		{ translates: routesTitle, prefixKey: 'routes' },
	]
});

const i18n = new VueI18n({
	locale: 'en',
	fallbackLocale: 'en',
	messages: jtf.loadMessages()
})

export const changeI18nLang = lang => {
	const html = document.querySelector('html');
	if (lang === 'ar') {
		html.setAttribute('dir', 'rtl');
	} else {
		html.setAttribute('dir', 'ltr');
	}
	localStorage.setItem('lang', lang);
	html.setAttribute('lang', lang);
	i18n.locale = lang;
}

if ('lang' in localStorage) {
	changeI18nLang(localStorage.lang);
} else {
	changeI18nLang('en');	
}

export default i18n;